import { getTixologiEvent, getTixologiEventPrivate } from "../utils";

import { useQuery } from "@tanstack/react-query";

interface UseTixologiEventReturn {
  data: Awaited<ReturnType<typeof getTixologiEvent>> | null | undefined;
  refetch: () => void;
  isLoading: boolean;
}

export function useTixologiEvent(
  eventId?: string,
  token?: string
): UseTixologiEventReturn {
  const { data, refetch, isLoading } = useQuery({
    queryKey: ["tixologiEvent", eventId, !!token],
    queryFn: () => {
      if (!eventId) return null;

      // If token is provided, use the private endpoint (for password-protected events)
      if (token) {
        return getTixologiEventPrivate(eventId, token);
      }

      // Otherwise, use the public endpoint
      return getTixologiEvent(eventId);
    },
    enabled: !!eventId && (token === undefined || token.length > 0),
  });

  return { data, refetch, isLoading };
}
